import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    NORMAL: {
        id: 'accountStatus.NORMAL',
        defaultMessage: 'Active',
    },
    ACCOUNT_CANCELLATION: {
        id: 'accountStatus.ACCOUNT_CANCELLATION',
        defaultMessage: 'Account Cancellation',
    },
    DEFINITIVE_CANCELLATION: {
        id: 'accountStatus.DEFINITIVE_CANCELLATION',
        defaultMessage: 'Definitive Cancellation',
    },
    BLOCK_JUDICIAL_BLOCKED: {
        id: 'accountStatus.BLOCK_JUDICIAL_BLOCKED',
        defaultMessage: 'Block Judicial Blocked',
    },
    CANCELLED: {
        id: 'accountStatus.CANCELLED',
        defaultMessage: 'Cancelled',
    },
    FULL_CANCELLATION: {
        id: 'accountStatus.FULL_CANCELLATION',
        defaultMessage: 'Full Cancellation',
    },
    BLOCKED: {
        id: 'accountStatus.BLOCKED',
        defaultMessage: 'Blocked',
    },
});

export default enumMessages;
